import { render, staticRenderFns } from "./StatusContact.vue?vue&type=template&id=b80ab926"
import script from "./StatusContact.vue?vue&type=script&lang=js"
export * from "./StatusContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b80ab926')) {
      api.createRecord('b80ab926', component.options)
    } else {
      api.reload('b80ab926', component.options)
    }
    module.hot.accept("./StatusContact.vue?vue&type=template&id=b80ab926", function () {
      api.rerender('b80ab926', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/StatusContact.vue"
export default component.exports